import listViewStore from 'owa-mail-list-store/lib/store/Store';
import ListViewStore from 'owa-mail-list-store/lib/store/schema/ListViewStore';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { action, select } from 'satcheljs/lib/legacy';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';

export interface MailItemContextMenuState {
    listViewStore: ListViewStore;
}

/**
 * Show the mail item context menu by initiating the itemContextMenuState
 * @param anchor the anchor where the mouse/keyboard event happens
 * @param the list view store which contains itemContextMenuState
 */
export let showMailItemContextMenu = action('showMailItemContextMenu')(
    select({
        listViewStore: () => listViewStore,
    })(function showMailItemContextMenu(
        anchor: IPoint,
        menuType: MailListContextMenuType,
        menuSource?: MailListContextMenuSource,
        state?: MailItemContextMenuState
    ): void {
        state.listViewStore.itemContextMenuState = {
            anchor: anchor,
            menuType: menuType,
            menuSource: menuSource,
        };
    })
);
/**
 * Hide the mail item context menu by clearing the itemContextMenuState
 */
export let hideMailItemContextMenu = action('hideMailItemContextMenu')(
    select({
        listViewStore: () => listViewStore,
    })(function hideMailItemContextMenu(state?: MailItemContextMenuState): void {
        state.listViewStore.itemContextMenuState = null;
    })
);
